import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppContext } from '../context/AppContext';

const useRedirectIfNoTariffs = () => {
  const { recommendedTariffs } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!recommendedTariffs?.length) {
      navigate('/app/tariffs');
    }
  }, [recommendedTariffs, navigate]);
};

export default useRedirectIfNoTariffs;
